/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

// @mui material components
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Icon from '@mui/material/Icon';
import Grid from '@mui/material/Grid';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';

function ExportSheetPrint() {
  const mod = 'export_sheet';
  const app = useSelector((state) => state[APP_STATE]);
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const slipRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => slipRef.current,
  });

  const print = () => {
    setLoading(true);
    setList([]);

    FetchData('OPTIONS', `/${mod}/print`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setList(result.list);

        setLoading(false);

        handlePrint();
      }
    });
  };

  const renderOrder = () => {
    return (
      <Grid container>
        {list.map((item) => (
          <Grid item xs={6} key={item.id}>
            <MDBox className='card-box text-center'>
              <CardHeader
                title={`#${item.export_code}`}
                subheader={Func.dateTimeDisplay(item.created_at)}
              />
              <CardMedia
                sx={{ height: 150, width: 150, margin: 'auto' }}
                image={item.image}
                title={item.export_code}
              />
              <CardContent>
                <MDTypography variant='body2'>สาขาโอนออก : {item.branch_name}</MDTypography>
                <MDTypography variant='body2'>สาขารับเข้า : {item.branch_import}</MDTypography>
              </CardContent>
            </MDBox>
          </Grid>
        ))}
      </Grid>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderPrint = () => {
    return (
      <div style={{ display: 'none' }}>
        <div ref={slipRef} className='print'>
          <div>
            <div className='a4'>{renderOrder()}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <MDButton variant='gradient' color='info' onClick={print}>
        <Icon>print</Icon>&nbsp;{t(`element.print`)}
      </MDButton>
      {renderLoading()}
      {renderPrint()}
    </div>
  );
}

export default ExportSheetPrint;
